import React, { useState } from 'react';


import dayjs from 'dayjs';

import { Button, Card, CardContent, Typography, TextField, Box, Grid } from '@mui/material';
import AlertDialog from '../input/AlertDialog';

const QUESTIONS = [
  'Did you find 5S user-friendly- Your Experience ?  (1 to 10)',
  'Do you Feel it will improve our Plants 5S Score by having more Images & Comments ? (1 to 10)',
  
];

const TEXT_QUESTIONS = [

  'Any Comments For improvements'
];

const FeedbackForm = ({ onSubmit, onRemindMe }) => {
  const [responses, setResponses] = useState({});

  const handleResponseChange = (question, value) => {
    setResponses({ ...responses, [question]: value });
  };

  const handleSubmit = () => {
    // Validate all questions are answered
    const allAnswered = QUESTIONS.every((question) => responses[question]) && 
                        TEXT_QUESTIONS.every((question) => responses[question]);

    if (!allAnswered) {
      AlertDialog({
        type: 'error',
        title: 'Form Incomplete',
        text: 'Please fill all the questions to submit the form.',
        confirmButtonText: 'OK',
      });
      return;
    }
    onSubmit(responses);
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', bgcolor: '#f9f9f9' }}>
      <Card sx={{ maxWidth: 800, width: '100%', p: 4, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h4" align="center" gutterBottom>
            Feedback Form
          </Typography>

          {QUESTIONS.map((question, index) => (
            <Box key={index} sx={{ mb: 4 }}>
              <Typography variant="h6" gutterBottom>
                  {question}<span style={{ color: "red" }}>* </span>
              </Typography>
              <Grid container spacing={1}>
                {[...Array(10)].map((_, i) => (
                  <Grid item key={i}>
                    <Button
                      variant={responses[question] === i + 1 ? 'contained' : 'outlined'}
                      color="primary"
                      onClick={() => handleResponseChange(question, i + 1)}
                      sx={{ minWidth: 40, height: 40 }}
                    >
                      {i + 1}
                    </Button>
                  </Grid>
                ))}
              </Grid>
            </Box>
          ))}

          {TEXT_QUESTIONS.map((question, index) => (
            <Box key={index} sx={{ mb: 4 }}>
              <Typography variant="h6" gutterBottom>
                {question}<span style={{ color: "red" }}>* </span>
              </Typography>
              <TextField
                fullWidth
                multiline
                rows={4}
                variant="outlined"
                value={responses[question] || ''}
                onChange={(e) => handleResponseChange(question, e.target.value)}
                placeholder="Write your comments here..."
              />
            </Box>
          ))}

          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 4 }}>
            <Button variant="contained" color="primary" 
            // onClick={() => onSubmit(responses)}
            onClick={handleSubmit}
            >
              Submit Feedback
            </Button>
            <Button variant="outlined" color="secondary" onClick={onRemindMe}>
              Remind Me
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default FeedbackForm;






